import ThemeSelectView from "./ThemeSelectView";

function ThemeSelect() {
  return <ThemeSelectView />;
}

export default ThemeSelect;
